import React from 'react';
import { LogOut } from 'lucide-react';
import { useSelector, useDispatch } from 'react-redux';
import { setLogout } from '../store/authSlice';

const LogoutButton = () => {
  const userDetails = useSelector((state) => state.auth.userDetails);
  const dispatch = useDispatch();

  const handleLogout = async () => {
    dispatch(setLogout());
  };

  return (
    <div className='flex fixed top-4 right-4 items-center z-50 pointer-events-auto'>
      {userDetails?.fullName && (
        <p className='text-white mr-2'>
          <span className='font-bold'>Welcome</span>{' '}
          {userDetails.fullName}
        </p>
      )}
      <button
        onClick={handleLogout}
        className='flex items-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg shadow-md transition-colors duration-200'
      >
        <LogOut className='w-5 h-5' />
        <span className='hidden sm:inline'>Logout</span>
      </button>
    </div>
  );
};

export default LogoutButton;
